import Register from "pages/public/Register";
import Login from "pages/public/Login";
import ForgotPassword from "pages/public/ForgotPassword";
import ResetPassword from "pages/public/ResetPassword";

import * as routeConfig from "Infrastructure/config/routesConfig.js";
import PaymentPlanDetails from "pages/private/PaymentPlan/PaymentPlanDetails";

const publicRoutes = [
  {
    label: "Login",
    path: routeConfig.getRoute(routeConfig.LOGIN),
    component: <Login />,
  },
  {
    label: "Register",
    path: routeConfig.getRoute(routeConfig.REGISTER),
    component: <Register />,
  },
  {
    label: "ForgotPassword",
    path: routeConfig.getRoute(routeConfig.FORGOT_PASSWORD),
    component: <ForgotPassword />,
  },
  {
    label: "Reset Password",
    path: routeConfig.getRoute(routeConfig.RESET_PASSWORD),
    component: <ResetPassword />,
  },
  {
    label: "Payment Details",
    path: routeConfig.getRoute(routeConfig.PAYMENT_PLAN_DETAIL_PUBLIC_ACCESS),
    component: <PaymentPlanDetails publicAccess={true} />,
  },
];

export default publicRoutes;
